
$(document).ready(function() {
  $('.privacy-banner button').on('click', function() {
      var className = 'your-new-class';
      
      // Add the class to the body
      $('body').addClass(className);
      
      // Store the class name in local storage
      localStorage.setItem('bodyClass', className);
  });

  // Optionally, you can apply the stored class from local storage when the page loads
  var storedClass = localStorage.getItem('bodyClass');
  if (storedClass) {
      $('body').addClass(storedClass);
  }
});



$(document).ready(function() {
  // Function to apply the stored class from local storage
  function applyStoredClass() {
      var storedClass = localStorage.getItem('bodyClass');
      if (storedClass) {
          $('body').addClass(storedClass);
      }
  }
  
  // Apply stored class when the page loads
  applyStoredClass();

  // Click event to add class and store it
  $('.privacy-banner button').on('click', function() {
      var className = 'your-new-class';
      
      // Add the class to the body
      $('body').addClass(className);
      
      // Store the class name in local storage
      localStorage.setItem('bodyClass', className);
  });
});




$(document).ready(function() {
  $('.pdp-full-list-ingredients').on('click', function() {
      $('.custom-overlay, .custom-popup').fadeIn();
      $('body').addClass('no-scroll');
  });

  $('.close-custom-popup, .custom-overlay').on('click', function() {
      $('.custom-overlay, .custom-popup').fadeOut();
      $('body').removeClass('no-scroll');
  });
});






window.arrowShape = 'M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z';

// For slider

$(document).ready(function() {
  var isMobile = window.matchMedia("(max-width: 768px)").matches;

  $('.main-carousel-review').flickity({
    lazyLoad: 2,  
    draggable: true,  
    initialIndex: 0,  
    wrapAround: true,         
    cellAlign: 'center',  
    pageDots: false,
    prevNextButtons: true,
    adaptiveHeight: isMobile // Only enable adaptiveHeight if on mobile
  });

  $('.people-are-talking-slider').flickity({
    lazyLoad: 2,  
    draggable: true,  
    initialIndex: 0,  
    wrapAround: true,         
    cellAlign: 'center',
    pageDots: false,
    prevNextButtons: true,
    adaptiveHeight: isMobile // Only enable adaptiveHeight if on mobile
  }); 


});
 
  $('.after-before-carousel').flickity({
    lazyLoad: 2,  
    draggable: true,  
    initialIndex: 0,  
    wrapAround: true,         
    cellAlign: 'center',
    pageDots: false,
    prevNextButtons: true
     
  });  


  var flickityOptions = {
    lazyLoad: 2,
    draggable: true,
    initialIndex: 0,
    wrapAround: true,
    cellAlign: 'center',
    pageDots: false,
    prevNextButtons: true,
    groupCells:  true,
    arrowShape: arrowShape
  }; 
  $('.loop-card-product').flickity(flickityOptions);

  $('.clode-btn-fliter').on('click', function() {
    $('.loop-card-product').flickity('destroy');
    $('.loop-card-product').flickity(flickityOptions);
  })

  $('.tablinks').on('click', function() {
    $('.loop-card-product').flickity('destroy');
    $('.loop-card-product').flickity(flickityOptions);
  });


 
  $('.blog-slider').flickity({
    lazyLoad: 2,  
    draggable: true,  
    initialIndex: 0,  
    wrapAround: false,         
    cellAlign: 'left',
    pageDots: false,
    prevNextButtons: true,
    arrowShape: arrowShape
  }); 






// // For collection tabs
// function openTab(evt, tabName) {
//   var i, tabcontent, tablinks;
//   tabcontent = document.getElementsByClassName("tabcontent");
//   for (i = 0; i < tabcontent.length; i++) {
//       tabcontent[i].style.display = "none";
//   }
//   tablinks = document.getElementsByClassName("tablinks");
//   for (i = 0; i < tablinks.length; i++) {
//       tablinks[i].className = tablinks[i].className.replace(" active", "");
//   }
//   var activeTab = document.getElementById(tabName);
//   activeTab.style.display = "block";
//   evt.currentTarget.className += " active";

//   if (window.innerWidth > 800) {
//       activeTab.scrollIntoView({ behavior: 'smooth', block: 'start' }); // Scroll to the top of the active tab content
//   }
// }


// Open the first tab by default
document.addEventListener("DOMContentLoaded", function() {
    // document.querySelector(".tablinks").click();
});

function scrollTabs(distance) {
  const container = document.querySelector('.tab-btns-list');
  container.scrollBy({ left: distance, behavior: 'smooth' });
}
// lemons animation

// const $items = $('.lemons-loop div');
// let index = 0;

// function showItem() {
//     $items.eq(index).removeClass('lemon'); 
//     index++;
//     if (index === $items.length) {
//         setTimeout(() => {
//             $items.each(function() {
//                 $(this).addClass('lemon');
//             }); 
//             index = 0;
//             setTimeout(showItem, 700);
//         }, 2000);
//         return;
//     }
//     setTimeout(showItem, 700);
// }

// showItem();


// lips dropdown


$(document).ready(function() {
  $('#product-drop-down-btn').click(function() {
      var $list = $('#myList');
      $(this).toggleClass('active')
      $list.slideToggle(100)
      $list.css('width', thisWidht)

     
  });
});


// fabulous dropdown
 
$(document).ready(function() {
  $('#variant-drop-down-btn').click(function() {
      $(this).toggleClass('active')
      var $list = $('#myfabulous');
      $list.slideToggle(100)

      // if ($list.height() === 0) {
      //     var autoHeight = $list.css('height', 'auto').height();
      //     $list.height(0).animate({ height: autoHeight }, 500);
      // } else {
      //     $list.animate({ height: 0 }, 500);
      // }


  });
});
 
//  dropdown sorting

$(document).ready(function() {
  var $myList = $('#myList');
  var $items = $myList.children('li');

  $items.sort(function(a, b) {
      var keyA = $(a).text().toUpperCase();
      var keyB = $(b).text().toUpperCase();
      return keyA.localeCompare(keyB);
  });

  $myList.append($items);
});


$(document).ready(function() {
  var $myList = $('#myfabulous');
  var $items = $myList.children('li');

  $items.sort(function(a, b) {
      var keyA = $(a).text().toUpperCase();
      var keyB = $(b).text().toUpperCase();
      return keyA.localeCompare(keyB);
  });

  $myList.append($items);
});

  // Select all list items
   const listItemsnew = document.querySelectorAll('#myfabulous li');

   // Select the element to update
   const labelnew = document.querySelector('.sechometag');
 
   // Add click event listener to each list item
   listItemsnew.forEach(item => {
     item.addEventListener('click', () => {
       // Update the labelnew text with the clicked list item's text content
       labelnew.textContent = item.textContent.trim();
     });
   }); 



  //  Select all list items
    const listItems = document.querySelectorAll('#myList li');

    // Select the element to update
    const label = document.querySelector('.firsthometag');

    // Add click event listener to each list item
    listItems.forEach(item => {
      item.addEventListener('click', () => {
        // Update the label text with the clicked list item's text content
        label.textContent = item.textContent.trim();
      });
    });


//  dropdown remove dublicate vales
 
function removeDuplicateListItems() {
  const $list = $('#myList, #myfabulous');
  const $items = $list.find('li');
  const seen = new Set();
  
  $items.each(function() {
    const text = $(this).text().trim().toLowerCase();
    if (seen.has(text)) {
      $(this).remove();
    } else {
      seen.add(text);
    }
  });
}

removeDuplicateListItems();

//  dropdown tags filtrring
let firstClass = '';
let secondClass = '';

function handleClick(event) {
    const clickedClass = $(event.target).closest('li').attr('class').split(' ')[0]; // Assuming each list item has only one class

    if ($(event.target).closest('ul').attr('id') === 'myList') {
        firstClass = clickedClass;
    } else if ($(event.target).closest('ul').attr('id') === 'myfabulous') {
        secondClass = clickedClass;
    }

    if (firstClass && secondClass) {
        const combinedClass = `${firstClass}-${secondClass}`;
        const products = $('.mysproduct');
        products.each(function() {
            const product = $(this);
            if (product.hasClass(combinedClass)) {
                product.css('display', 'grid');
            } else {
                product.css('display', 'none');
            }
        });
    }  
}

$('#myList li, #myfabulous li').click(handleClick);
 

$(document).ready(function(){
  $('#myList li, #myfabulous li').click(function(){
    // Remove 'active' class from all other siblings
    $(this).siblings().removeClass('active');
    // Toggle 'active' class on the clicked li
    $(this).toggleClass('active');
  });
});
 
$(document).ready(function() {
  $('.product-card__figure').mouseover(function() {
    $(this).find('.collection_img_carousel').addClass('is-hovered');
  });

  $('.product-card__figure').mouseleave(function() {
    $(this).find('.collection_img_carousel').removeClass('is-hovered');
  });
});


$('.beauty-litsslider').flickity({
  lazyLoad: 2,  
  draggable: true,  
  initialIndex: 0,  
  wrapAround: true,         
  cellAlign: 'center',
  pageDots: false,
  prevNextButtons: true
   
});
  

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
      document.querySelectorAll('#myList li.lips').forEach(function(element) {
          element.click();
      });
      document.getElementById('myList').style.display = 'none';
  }, 2000); // 2000 milliseconds = 2 seconds
});


// Filter popup

$(document).ready(function() {
  // Event delegation for the popup open button
  $(document).on("click", "#open-popup-filter", function() {
      $("body").addClass("no-scroll");
      $("#overlay-filter, #popup-filter").fadeIn();
  });
 
  // Event delegation for closing the popup
  $(document).on("click", "#popup-filter .close-filter, #overlay-filter, .clode-btn-fliter", function() {
      $("body").removeClass("no-scroll");
      $("#overlay-filter, #popup-filter").fadeOut();
  });

});

// Product details tab

 
function customOpenTab(event, tabId) {
  var $tabContentElements = $(".custom-tab-content");
  var $tabLinkElements = $(".custom-tab-link");

  // Hide all tab contents
  $tabContentElements.hide();

  // Remove the class "active" from all tab links
  $tabLinkElements.removeClass("active");

  // Show the current tab with fade animation and add an "active" class to the link that opened the tab
  $("#" + tabId).fadeIn();
  $(event.currentTarget).addClass("active");
}

function customOpenAccordion(event, tabId) {
  var $accordionContentElements = $(".custom-tab-content");
  var $accordionLinkElements = $(".custom-accordion-link");

  // Get the current accordion link and content
  var $currentLink = $(event.currentTarget);
  var $currentContent = $("#" + tabId);

  if ($currentLink.hasClass("active")) {
    // If the clicked link is already active, hide the content and remove the "active" class
    $currentContent.fadeOut();
    $currentLink.removeClass("active"); 
  } else {
    // Hide all accordion contents
    $accordionContentElements.hide();

    // Remove the class "active" from all accordion links
    $accordionLinkElements.removeClass("active");

    // Show the current accordion content with fade animation and add an "active" class to the link that opened the accordion
    $currentContent.fadeIn();
    $currentLink.addClass("active");
  }
}

// Ensure the content is only displayed in the appropriate view
function handleResize() {
  var $tabs = $('.custom-tabs');
  var $accordionLinks = $('.custom-accordion-link');
  var $tabContents = $('.custom-tab-content');
  
  if ($(window).width() >= 700) {
      $tabs.show();
      $accordionLinks.hide();
      $tabContents.each(function() {
          if ($(this).prev().hasClass('active')) {
              $(this).show();
          } else {
              $(this).hide();
          }
      });
  } else {
      $tabs.hide();
      $accordionLinks.show();
      $tabContents.each(function() {
          if ($(this).prev().hasClass('active')) {
              $(this).show();
          } else {
              $(this).hide();
          }
      });
  }
}

// Call handleResize on window resize
$(window).resize(handleResize);

// Call handleResize on document ready
$(document).ready(handleResize);


// Initial check for view on page load
$(window).on('resize', handleResize);
$(document).ready(function() {
  handleResize();
});


// Accordion for product tab
  

$(document).ready(function(){
  // Show first accordion-body and add active class to first accordion-header
  $('.accordion-header:first').addClass('active');
  $('.accordion-body:first').show();
  
  $('.accordion-header').click(function() {
      // Toggle active class
      $(this).toggleClass('active');
      
      // Toggle accordion body
      $(this).next('.accordion-body').slideToggle(200);
      
      // Collapse other accordion bodies and remove active class from other headers
      $('.accordion-body').not($(this).next('.accordion-body')).slideUp(200);
      $('.accordion-header').not($(this)).removeClass('active');
  });
});
 

// $(document).on('click', '.buy-buttons .button', function (e) {
//   e.preventDefault();

//   const $addToCartForm = $(this).closest('form');
//   var selectedAddOn = $addToCartForm.find(".product-checkbox:checked").first();

//   // Check if any checkbox is checked
//   if (selectedAddOn.length > 0) {
//     var selectedVariants = [];
    
//     // Add main product variant
//     var mainProductId = $addToCartForm.find("input[name='id']").val();
//     selectedVariants.push({
//       id: mainProductId,
//       quantity: 1,
//     });

//     // Add selected add-on variant
//     var addOnVariantId = selectedAddOn.data("product-id");
//     selectedVariants.push({
//       id: addOnVariantId,
//       quantity: 1,
//     });

//     // Send AJAX request only if variants are selected
//     if (selectedVariants.length > 0) {
//       $.ajax({
//         type: "POST",
//         url: "/cart/add.js",
//         data: { items: selectedVariants },
//         dataType: "json",
//         success: function () {
//           console.log("Products added to cart");
//           // Trigger custom event to refresh the cart drawer
//           document.dispatchEvent(new CustomEvent('cart:refresh'));
//           // Trigger custom event to show the cart drawer
//           document.dispatchEvent(new CustomEvent('show-cart-drawer'));

//           // Programmatically trigger click on the cart link
//           var cartLink = document.querySelector('a[href="/cart"]');
//           if (cartLink) {
//             cartLink.click();
//           }
//         },
//         error: function () {
//           console.log("Error adding products to cart");
//           // Handle error, e.g., display an error message to the user
//         }
//       });
//     } else {
//       console.log("No products selected");
//     }
//   } else {
//     // If no checkbox is checked, add only default product to cart
//     var defaultVariantId = $addToCartForm.find("input[name='id']").val();
//     $.ajax({
//       type: "POST",
//       url: "/cart/add.js",
//       data: { items: [{ id: defaultVariantId, quantity: 1 }] },
//       dataType: "json",
//       success: function () {
//         console.log("Default product added to cart");
//         // Trigger custom event to refresh the cart drawer
//         document.dispatchEvent(new CustomEvent('cart:refresh'));
//         // Trigger custom event to show the cart drawer
//         document.dispatchEvent(new CustomEvent('show-cart-drawer'));

//         // Programmatically trigger click on the cart link
//         var cartLink = document.querySelector('a[href="/cart"]');
//         if (cartLink) {
//           cartLink.click();
//         }
//       },
//       error: function () {
//         console.log("Error adding default product to cart");
//         // Handle error, e.g., display an error message to the user
//       }
//     });
//   }
//   return false;
// });

//  For Section scroll effect

$(document).ready(function() {
  function checkScroll(sectionClass, activeClass) {
      var scrollPosition = $(window).scrollTop();
      var windowHeight = $(window).height();
      var sectionTop = $(sectionClass).offset().top;
      var sectionHeight = $(sectionClass).outerHeight();
      var sectionBottom = sectionTop + sectionHeight;
      var threshold = sectionHeight * 0.4;

      if (scrollPosition + windowHeight > sectionBottom - threshold) {
          $(sectionClass).addClass(activeClass);
      } else {
          $(sectionClass).removeClass(activeClass);
      }
  } 

  $(window).on('scroll', function() {
    
      checkScroll('.home-ingredients-scrollw', 'active-scroll');
    
 


  
  });  
});
 

// For Mega menu Products

// $(document).ready(function() {
//   const $tabs = $('.mega-menu__linklist li');
//   const $defaultImage = $('.menu-default-product');
//   const $images = $('.simple-product');

//   $tabs.on('mouseenter', function() {
//       const imageClass = $(this).data('image');

//       $images.removeClass('active');
//       $defaultImage.addClass('hidden');
//       $('.' + imageClass).addClass('active');
//   });

//   $tabs.on('mouseleave', function() {
//       $images.removeClass('active');
//       $defaultImage.removeClass('hidden');
//   });

//   $('.menu-product-section').on('mouseleave', function() {
//       $images.removeClass('active');
//       $defaultImage.removeClass('hidden');
//   });
// });

$(document).ready(function(){
  $('#myVideo').prop('muted', true).get(0).play();
});
 

$(document).ready(function() {
  $('.header__primary-nav-item .header__menu-disclosure').hover(
      function() {
          $('slideshow-carousel.slideshow').addClass('active');
      },
      function() {
          $('slideshow-carousel.slideshow').removeClass('active');
      }
  );
}); 



$(document).ready(function() {
  // Function to update tab counts
  function updateTabCounts() {
      var tabCounts = {};
      $('.about-tab').each(function() {
          var tabClass = $(this).attr('class').split(' ')[1];
          tabCounts[tabClass] = $('.about-content-section.' + tabClass).length;
          $(this).find('.tab-count').text('' + tabCounts[tabClass] + '');
      });

      // Update Show All tab count
      var totalCount = 0;
      Object.keys(tabCounts).forEach(function(key) {
          totalCount += tabCounts[key];
      });
      $('.show-all .tab-count').text('' + totalCount + '');
  }

  // Initial update of tab counts
  updateTabCounts();

  // Click handler for tabs
  $('.about-tab').click(function() {
      var tabClass = $(this).attr('class').split(' ')[1]; // Get the second class (tab1, tab2, tab3, etc.)
      
      if (tabClass === 'show-all') {
          $('.about-content-section').addClass('active'); // Show all content sections
          $('.about-tab').removeClass('active'); // Remove active class from all tabs
          $(this).addClass('active'); // Add active class to Show All tab
      } else {
          $('.about-content-section').removeClass('active'); // Remove active class from all content sections
          $('.' + tabClass).addClass('active'); // Add active class to corresponding content section
          $('.about-tab').removeClass('active'); // Remove active class from all tabs
          $(this).addClass('active'); // Add active class to clicked tab
      }
  });

  // Open the first tab by default
  $('.natural-extracts').addClass('active');
  $('.about-content-section.natural-extracts').addClass('active');
});

 

// $(document).ready(function(){
//   var perPage = 12; // Number of images to show initially
//   var totalBlocks = {{ totalBlocks }};
//   var currentPage = 1;

//   function showBlocks(startIndex, endIndex) {
//     $('.inner-ingredient-grid  .active').slice(startIndex, endIndex).show();
//   }
//   $('#load-more-btn').on('click', function(){
//     var startIndex = currentPage * perPage;
//     var endIndex = Math.min(startIndex + perPage, totalBlocks);
//     showBlocks(startIndex, endIndex);
//     if (endIndex >= totalBlocks) {
//       $(this).hide(); // Hide the button when all blocks are shown
//     }
//     currentPage++;
//   });
//   // Initially hide all blocks beyond the first 6
//   $('.inner-ingredient-grid  .active:gt(11)').hide();

//   // Hide the load more button initially if all blocks are visible
//   if (totalBlocks <= perPage) {
//     $('#load-more-btn').hide();
//   }
// });

$('body').on('click','form[is="facets-form"] .accordion-list > h6', function() {
  $(this).next().addClass('active');
});

$('body').on('click','.filter-sidebar_collapsible .filter-back-btn', function() {
  $(this).closest('.filter-sidebar_collapsible').removeClass('active');
});




  // For Color Variants

let product_title = $('#custom-colors-wrap').attr('data-title');
product_title = product_title.split('-')[0];
console.log('product_title:::', product_title);

// Fix: Ensure we split the original product_title, not the one already split
let secondTitle = $('#custom-colors-wrap').attr('data-title').split('-')[1];
if (secondTitle) {
  secondTitle = secondTitle.split(',')[1]; // Check if secondTitle exists before splitting by comma
  console.log('product_title secondTitle:::', secondTitle);
}

let searchTerm = product_title + (secondTitle || ''); // Fix: Use the actual searchTerm variable and handle undefined secondTitle
console.log('searchTerm:::', searchTerm);

let oldsearchTerm = product_title;

$.ajax({
  url: `/search?q=${searchTerm.toLowerCase()}`,
  success: function(data) {  
    let container = $('#custom-colors-wrap');
    let sizeContainer = $('#custom-size-wrap');
    let currentTitle = $('h1.product-title.h3').text();
    container.empty();
    sizeContainer.empty();
    $(data).find('.main-product-card').each(function() {
      let fullTitle = $(this).find('.product-title').text();
      if(fullTitle.includes(' -')){
        let title = $(this).find('.product-title').text().trim().split('-')[0];
        if (title.toLowerCase() === oldsearchTerm.toLowerCase()) {
          let link = $(this).find('.product-title').attr('href');
          let title = $(this).find('.product-title').text();
          let swatchColor = $(this).find('.main-product-card-inners').attr('data-swatch-color');
          let img = $(this).find('.main-product-card-inners').attr('data-second-image');
          let html=`<a href="${link}" title="${title}">`;
            html+=`<div class="variants_product_item" style="background-image:url(${img})"></div>`;
            html+='</a>';
          container.append(html);
          container.closest('.select-color-wrap').addClass('active');
        }
        // if (title.toLowerCase() === searchTerm.toLowerCase()) {
        //   let link = $(this).find('.product-title').attr('href');
        //   let title = $(this).find('.product-title').text();
        //   let sizeValue = $(this).find('.main-product-card-inners').attr('data-size');
        //   let sizeValueLength = $(this).find('.main-product-card-inners').attr('data-sizeValueLength');
        //   let activehtml = '';
        //   if(currentTitle.toLowerCase() == title.toLowerCase()){
        //     activehtml = 'active'; 
        //    } 
        //    if(sizeValueLength < 2){
        //     let html=`<a class="${activehtml}" href="${link}" title="${title}">`;
        //     html+=`<div class="variant-size-item">${sizeValue}</div>`;
        //     html+='</a>';
        //     sizeContainer.append(html);
        //    }
        //   sizeContainer.closest('.select-size-wrap').addClass('active');
        // }
      }
    });
  }
});
